import { useNavigate } from "react-router-dom";

/**
 * Friendly landing page shown at `/`, on any unmatched path, or when a link ID
 * can't be resolved or has been disabled.
 */
export default function BookingLanding({ error, disabled }) {
  const navigate = useNavigate();

  // Determine the type of error
  const isDisabled = disabled || error?.includes("disabled");

  return (
    <>
      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: none; } }
        @keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: .5; } }
      `}</style>

      <div style={{ minHeight: "100vh", background: "#F5FAFA", fontFamily: "-apple-system,'Segoe UI',system-ui,sans-serif", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 16px" }}>
        <div style={{ textAlign: "center", maxWidth: 460, animation: "fadeUp .5s ease both" }}>

          {/* Animated icon */}
          <div style={{ animation: "float 3s ease-in-out infinite", marginBottom: 28 }}>
            <img src="/logo_symbol.png" alt="Mekorma" style={{ width: 80, height: 80, margin: "0 auto", display: "block" }} />
          </div>

          <h1 style={{ fontSize: 26, fontWeight: 700, color: "#0F172A", margin: "0 0 10px", lineHeight: 1.3 }}>
            {isDisabled
              ? "This booking link is inactive"
              : error
                ? "Hmm, this link doesn't work"
                : "Booking link needed"
            }
          </h1>

          <p style={{ fontSize: 15, color: "#64748B", margin: "0 0 8px", lineHeight: 1.7 }}>
            {isDisabled
              ? "This booking link has been temporarily disabled by the administrator."
              : error
                ? "We couldn't find a valid booking session for this URL. The link may have expired or been removed."
                : "It looks like you arrived here without a valid booking link."
            }
          </p>

          <p style={{ fontSize: 14, color: "#94A3B8", margin: "0 0 32px", lineHeight: 1.6 }}>
            {isDisabled
              ? "If you believe this is an error, please contact the person who shared this link with you."
              : "Please check the link you received and try again, or contact the person who shared it with you."
            }
          </p>

          {/* Helpful tips */}
          <div style={{ background: "#fff", border: "1.5px solid #E2E8F0", borderRadius: 14, padding: "20px 24px", textAlign: "left", marginBottom: 28 }}>
            <p style={{ fontSize: 12, fontWeight: 600, color: "#64748B", textTransform: "uppercase", letterSpacing: "0.04em", margin: "0 0 12px" }}>
              What you can try
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                { icon: "1", text: "Double-check the URL for typos or missing characters" },
                { icon: "2", text: "Ask the sender to share the link again" },
                { icon: "3", text: "Make sure you're using the complete link" },
              ].map((tip) => (
                <div key={tip.icon} style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                  <span style={{
                    width: 22, height: 22, borderRadius: "50%", background: "#E8F2EF", color: "#004e42",
                    fontSize: 11, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                  }}>
                    {tip.icon}
                  </span>
                  <span style={{ fontSize: 13, color: "#374151", lineHeight: 1.5 }}>{tip.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Footer */}
          <p style={{ fontSize: 11, color: "#CBD5E1" }}>
            <span style={{ color: "#88c96c", fontWeight: 700 }}>Mekorma</span> · Booking Platform · Powered by Microsoft Graph, Bookings and Dynamics CRM
          </p>
        </div>
      </div>
    </>
  );
}
